module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-10-ffa02116.png";